import React from 'react'
import { Route, Routes } from "react-router-dom";
import InvitationsPage from '../../pages/features/invitations/InvitationsPage';




export default function InvitationNav() {
  return (
    <Routes>
      <Route path="/" element={<InvitationsPage />} />
      

    </Routes>
  );
}
